<template>
  <div class="service-rigth_flex" v-if="showFlex">
    <el-popover
      popper-class="pc-service_btn"
      v-model="show"
      placement="left-end"
      width="400"
      trigger="manual"
      :visible-arrow="false"
    >
      <div class="prpover-header">
        {{ $t("Datalang.VIP_BTM_contactus") }}
        <i class="el-icon-circle-close" @click="show = false"></i>
      </div>
      <div class="work-time">
        <img class="kefuPic" :src="kefuPic" alt />
        <!-- {{ $t("Datalang.VIP_TIP_anyquestionpleasecontact") }}
        <br />
        {{ $t("Datalang.VIP_TITLE_mondaytosunday") }}：8:00-24:00 -->
        <div class="kefuDiv" v-html="serviceInfo"></div>
      </div>
      <ServiceChannel />
      <!-- v-if="!isMobile()" -->
      <div slot="reference" :id="888" @click="showPopover" v-drag class="scale-item kehu hidden-xs-only">
        <span href="javascript:void(0)">
          <img
            class="kefu_icon"
            v-exposure="{ eid: `101_27_0_0` }"
            :data-id="`101_27_0_0`"
            :draggable="false"
            :src="require(`@/assets/user/kefu_btn.png`)"
            alt
          />
        </span>
      </div>
    </el-popover>
  </div>
</template>

<script>
import CustomerService from "@/lobby_common/mixins_components/CustomerService/CustomerService.js";
export default {
  components: {},
  props: [],
  mixins: [CustomerService],
  data() {
    return {};
  },
  filters: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss">
.pc-service_btn {
  width: 100% !important;
  max-width: 400px !important;
  padding: 0 20px 10px;
  box-sizing: border-box;
  border-radius: 10px;
  word-break: break-word;
  background: var(--popup-100);
  border: none;
  max-height: 90%;
  overflow: auto;
  .prpover-header {
    color: var(--font-color-100);
    font-size: 24px;
    text-align: center;
    position: relative;
    padding: 14px 0;

    .el-icon-circle-close {
      position: absolute;
      right: 0;
      font-size: 26px;
      cursor: pointer;
    }
  }

  .work-time {
    text-align: center;
    font-size: 16px;
    color: var(--font-color-1100);
    margin: 0 -20px;
    position: relative;
    height: 180px;
    .kefuPic {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      z-index: 1;
    }
    .kefuDiv {
      position: absolute;
      z-index: 2;
      width: 55%;
      left: 10px;
      top: 10px;
      text-align: left;
      word-break: break-word;
      font-size: 14px;
    }
  }
}

.service-rigth_flex {
  position: fixed;
  bottom: 20px;
  right: 25px;
  z-index: 2000;

  .scale-item {
    padding: 14px;
    border-radius: 10px;
    background: var(--background-1400);
    width: 70px;
    height: 70px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    transition: background ease 0.5s;
  }

  .kehu .kefu_icon {
    width: 42px;
    height: 42px;
    cursor: pointer;
  }

  .kehu .imgIcon {
    width: 91px;
    height: 51px;
    position: absolute;
    left: -21px;
    bottom: -50px;
  }
}

@media (max-width: 500px) {
  .service-rigth_flex {
    bottom: 100px;
    right: 25px;

    .scale-item {
      transform: scale(0.75);
    }
  }
}
</style>
